"use client";

import type { FC } from "react";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { RichText } from "@payloadcms/richtext-lexical/react";
import type { SerializedEditorState } from "@payloadcms/richtext-lexical/lexical";

export interface QuestionDescriptionProps {
  /** Lexical rich-text JSON content from PayloadCMS. */
  content?: SerializedEditorState | Record<string, unknown>;
  /** Passed through to the container as `data-testid`. */
  testId?: string;
}

/**
 * Caption-style helper text rendered next to a form-funnel question or hosted step.
 * Returns null when no content is supplied so callers can render it unconditionally.
 */
export const QuestionDescription: FC<QuestionDescriptionProps> = ({
  content,
  testId = "question-description",
}) => {
  if (!content || !("root" in content)) return null;

  return (
    <DescriptionText role="note" data-testid={testId}>
      <RichText data={content as SerializedEditorState} />
    </DescriptionText>
  );
};

const DescriptionText = styled(Box)`
  width: 100%;
  font-size: 14px;
  line-height: 1.5;
  color: #7c7978;
  text-align: center;

  p {
    margin: 0 0 4px 0;
  }

  p:last-child {
    margin-bottom: 0;
  }

  strong,
  b {
    color: #4a4a4a;
  }

  a {
    color: #3f3770;
    text-decoration: underline;
  }

  ul,
  ol {
    padding-left: 20px;
    margin: 2px 0;
    text-align: left;
  }
`;
